<template>
    <div id="app">
        <screen-view></screen-view>
    </div>
</template>

<script>
    import ScreenView from './components/screen-view.vue';

    export default {
        components : { ScreenView }
    }
</script>